import { useCallback } from "react";
import { CameraImage } from "../types";

interface CameraCaptureResult {
  captureImage: (webcamRef: React.RefObject<any>) => Promise<CameraImage | null>;
  dataUrlToFile: (dataUrl: string, fileName: string) => File;
}

export const useCameraCapture = (): CameraCaptureResult => {
  const captureImage = useCallback(async (webcamRef: React.RefObject<any>): Promise<CameraImage | null> => {
    try {
      if (!webcamRef.current) {
        throw new Error("Camera not ready");
      }

      const dataUrl = webcamRef.current.getScreenshot();
      if (!dataUrl) {
        throw new Error("Failed to capture screenshot");
      }

      const base64 = dataUrl.split(",")[1];
      if (!base64) {
        throw new Error("Invalid image format");
      }

      return {
        base64,
        dataUrl,
        timestamp: Date.now(),
      };
    } catch (error) {

      return null;
    }
  }, []);

  const dataUrlToFile = useCallback((dataUrl: string, fileName: string): File => {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)?.[1] || "image/jpeg";
    const bstr = atob(arr[1]);
    const n = bstr.length;
    const u8arr = new Uint8Array(n);

    for (let i = 0; i < n; i++) {
      u8arr[i] = bstr.charCodeAt(i);
    }

    return new File([u8arr], fileName, { type: mime });
  }, []);

  return {
    captureImage,
    dataUrlToFile,
  };
};
